import React from "react";
import useTable from "../../../../MainComponents/Hooks/useTable";
import HelmetTags from "../../../../MainComponents/HelmetTags";

const ViewAssistantCodes = () => {
  const table = useTable("ViewAssistantCodes");

  return (
    <section className="h-full w-full overflow-y-auto px-20 py-20 sm:px-10 ">
      <HelmetTags title={`View Assistant Codes | Nash Academy`}></HelmetTags>
      <h2 className="mb-7 text-start sm:text-center text-4xl font-bold">
        View Assistant Codes
      </h2>
      {/* Table */}
      <div className="h-fit w-full">{table}</div>
    </section>
  );
};

export default ViewAssistantCodes;
